import options from './add.component';

export default {
    selector: 'dtFolderTreeAddFolder',
    options
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folder-tree/add-folder/index.js